export const TAB_NOTIFICATION_STATE = {
  Default: 'default',
  Incoming: 'incoming',
  Active: 'active',
} as const;

export type TabNotificationState =
  (typeof TAB_NOTIFICATION_STATE)[keyof typeof TAB_NOTIFICATION_STATE];
